

















































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
 import AbpBase from '@/lib/abpbase';
 import Util from '@/lib/util';
 import contactInfo from "@/store/entities/jm/hzcontactitem";
 @Component
export default class HZContactEdits extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:String,default:"0"}) contactid:string;
    title:string ="编辑被函询人信息";
    loading:boolean=false;
    loadingInstance:boolean=false;
    currContact:contactInfo = new contactInfo();
    contactRules={
        address:[{required:true,message: '地址不能为空',trigger: 'blur'}],
        contactPerson:[{required:true,message: '联系人不能为空',trigger: 'blur'}],
        phone:[{required:true,message: '联系方式不能为空',trigger: 'blur'}],
        email:[{required:true,message: 'Email地址不能为空',trigger: 'blur'}]
    }
    visibleChange(value) {
      if (!value) {
        (this.$refs["contactRef"] as any).resetFields();
        this.$emit('input',false);
      }
      else{
        this.getdata();
      }
    }
    cancel(){
      (this.$refs["contactRef"] as any).resetFields();
      this.$emit('input',false);
    }
    save(){
        (this.$refs["contactRef"] as any).validate(async (valid) => {
                if (valid) {
                this.loading=true;
                let response=await this.$store.dispatch({
                    type:'hzcontact/save',
                    data:this.currContact
                });
                if(response.success){
                    this.loading=false;
                    (this.$refs["contactRef"] as any).resetFields();
                    this.$emit('input',false);
                    this.$emit('save-success');
                    this.$message({
                    message: '保存成功',
                    type: 'success'
                    });
                }
                else{
                    this.$message({
                    message: response.message,
                    type: 'error'
                    });
                    this.loading=false;
                } 
                } else {
                return false;
                }
            });
    }
    get jobauth(){
       let d= this.$store.state.jobdo.roles;
       if(d.length>0){
          return d[0].checked=='1'?true:false;
       }
       return false;
    }
    async getdata(){
      this.loadingInstance=true;
       let currid=this.$store.state.jobdo.currjob;
       var response=await this.$store.dispatch({
           type:'hzcontact/getitem',
           data:{ProjectId:currid,Id:this.contactid}
       });
       if(response.length>0){
          this.currContact=Util.extend(true,{},response[0]);
          this.title='编辑被函询人>'+this.currContact.contactName;
       } 
       this.loadingInstance=false;
   }
}
